// extracted by mini-css-extract-plugin
module.exports = {"modal":"PrivacyPolicyModal_modal__71T4s"};